export default __webpack_public_path__ + "static/media/billing.9a74789d.svg";